<template>
  <div class="visa-open-class-page">
    <div class="class-type-nav">
      <div
        class="class-type-item"
        v-for="typeItem in allTypes"
        :key="typeItem.id"
        @click="changeType(typeItem.id)"
        :class="{ active: currentSecondId === typeItem.id }"
      >
        {{ typeItem.name }}
      </div>
    </div>
    <div
      class="videos-box"
      v-if="loaded && allVisaClasses && allVisaClasses.length > 0"
    >
      <visa-video-item
        v-for="video in allVisaClasses"
        :video-info="video"
        :key="video.id"
      ></visa-video-item>
    </div>
    <div
      class="video-list-null"
      v-if="loaded && allVisaClasses && allVisaClasses.length === 0"
    >
      <img
        class="image"
        src="https://o.666visa.cn/static/ssqwxa/peer_shop/article-null.png"
      />
      <div class="text">暂无视频</div>
    </div>
    <div class="bottom-page-box" v-if="totalCount > 0">
      <span class="total-count">共 {{ totalCount }} 条</span>
      <el-pagination
        class="page-box"
        @current-change="currentPageChange"
        :current-page="page"
        :page-size="countPerPage"
        layout="prev, pager, next"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import visaVideoItem from "./components/visa-video-item";
import knowledgeService from "../../services/knowledge-service";
import { visaOpenClassType } from "../../constants/knowledge-constants";

export default {
  name: "visa-open-class-page",
  components: {
    visaVideoItem,
  },
  data() {
    return {
      allVisaClasses: [],
      totalCount: 0,
      countPerPage: 12,
      currentSecondId: 0,
      page: 1,
      sysConfig: {},
      loaded: false,
    };
  },
  computed: {
    allTypes() {
      if (this.sysConfig.video_second_id_list) {
        const currentArr = [...this.sysConfig.video_second_id_list[1]].sort();
        const result = [
          {
            name: "全部",
            id: 0,
          },
        ];

        currentArr.forEach((id) => {
          result.push({
            id,
            name: visaOpenClassType[id - 1],
          });
        });

        return result;
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions("config/", ["getSysConfig"]),

    changeType(secondCatalogId) {
      this.currentSecondId = secondCatalogId;
      this.getBriefOpenClass(secondCatalogId);
    },

    currentPageChange(currentPage) {
      this.page = currentPage;
      this.getBriefOpenClass(this.currentSecondId);
    },

    getBriefOpenClass(secondCatalogId) {
      knowledgeService
        .visaVideoBriefQuery({
          catalog_id: 1,
          second_catalog_id: secondCatalogId,
          page: this.page,
          per_page: this.countPerPage,
        })
        .then((data) => {
          this.totalCount = data.total_count;
          this.allVisaClasses = data.page_data;
          this.loaded = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getSysConfig().then((data) => {
      this.sysConfig = data;
      this.getBriefOpenClass(0);
    });
  },
};
</script>

<style lang="less" scoped>
.visa-open-class-page {
  display: flex;
  flex-direction: column;
  .class-type-nav {
    margin-top: 40px;
    width: 1120px;
    height: 61px;
    background: #fafbfc;
    border-radius: 2px;
    border: 1px solid #f0f0f0;
    padding-left: 34px;
    display: flex;
    align-items: center;
    .class-type-item {
      cursor: pointer;
      margin-right: 40px;
      font-size: 16px;
      font-weight: 400;
      color: #2f333d;
      line-height: 16px;
      &:hover,
      &.active {
        color: #599fff;
      }
    }
  }
  .videos-box {
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;
  }
  .video-list-null {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 100px;
    .text {
      margin-top: 20px;
      font-size: 20px;
      color: #91999f;
    }
  }
  .bottom-page-box {
    margin-top: 48px;
    align-self: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .total-count {
      font-size: 16px;
      font-weight: 400;
      color: #5f666e;
      line-height: 16px;
    }
    .page-box {
      margin-left: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/VisaOpenClass.vue